import Image from 'next/image'
import { forwardRef } from 'react'
import { m, LazyMotion, domAnimation } from 'framer-motion'

import ValueAimPicture from '../../../assets/backgrounds/values-aim.webp'
import ValueCarePicture from '../../../assets/backgrounds/values-care.webp'
import ValueCommitPicture from '../../../assets/backgrounds/values-commit.webp'
import ValueTrustPicture from '../../../assets/backgrounds/values-trust.webp'
import ValueTruthPicture from '../../../assets/backgrounds/values-truth.webp'

import styles from './index.module.scss'

// Animations
const ANIMATION_PROPS = {
  variants: {
    start: { y: '50%', opacity: 0.1 },
    end: {
      y: '0%',
      opacity: 1,
      transition: { type: 'spring', bounce: 0 },
    },
  },
  initial: 'start',
  whileInView: 'end',
  viewport: { once: true },
}

const CARDS = [
  {
    title: { highlight: 'When the truth is told,', text: ' transparency unfolds' },
    description:
      'We have a safe and open environment that allows transparent communication to flourish clearly and fluidly.',
    picture: ValueTruthPicture,
  },
  {
    title: { highlight: 'Aim high,', text: ' beyond the sky' },
    description:
      'We are in constant movement. That’s why we think big and see new challenges as a form of continuous growth.',
    picture: ValueAimPicture,
  },
  {
    title: { highlight: 'Between us,', text: ' there is trust' },
    description:
      'We give freedom to people to perform their best because we trust in one another. We genuinely embrace the sense of confidence.',
    picture: ValueTrustPicture,
  },
  {
    title: { highlight: 'We commit,', text: " we don't quit" },
    description:
      'We take responsibility for what we commit to, from beginning to end. We charge ourselves with passion and energy, and never take the easy way out.',
    picture: ValueCommitPicture,
  },
  {
    title: { highlight: 'We take care,', text: ' no matter where' },
    description:
      'We think collectively and work towards a common goal. That’s why we always have each other’s back, even from miles apart. As a team, we always aim for mutual success.',
    picture: ValueCarePicture,
  },
]
export const AboutUsOurValues = forwardRef<HTMLElement>((_, ref) => {
  return (
    <section ref={ref} className={styles['wrapper']}>
      <LazyMotion features={domAnimation} strict>
        <div className={styles['content']}>
          <m.h2 className={styles['title']} {...ANIMATION_PROPS}>
            <span className={styles['highlight']}>Our</span> values
          </m.h2>
          <m.p className={styles['description']} {...ANIMATION_PROPS}>
            Values make our culture tangible. They guide Olbers on their journeys, to fly higher and
            move further, day by day.
          </m.p>
          <div className={styles['cards-wrapper']}>
            {CARDS.map(card => (
              <m.div className={styles['card']} {...ANIMATION_PROPS}>
                <Image
                  src={card.picture}
                  alt="background"
                  fill
                  className={styles['background-image']}
                />
                <h3 className={styles['card-title']}>
                  <span className={styles['highlight']}>{card.title.highlight}</span>
                  <br />
                  {card.title.text}
                </h3>
                <p className={styles['card-description']}>{card.description}</p>
              </m.div>
            ))}
          </div>
        </div>
      </LazyMotion>
    </section>
  )
})
